import React, {useEffect, useState} from "react";
import {LoggedInView} from "../common/LoggedInView";
import {Link, useParams} from "react-router-dom";
import {ClientSearch} from "./components/ClientSearch";
import {ClientsTable} from "./components/ClientsTable";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {getClients} from "../../store/reducers/ClientsSlice";
import Pagination from "../common/Pagination";

interface ClientsScreenProps {
}

export const ClientsScreen: React.FC<ClientsScreenProps> = () => {

    const dispatch = useAppDispatch();
    const routeParams = useParams();

    const calientsState = useAppSelector(state => state.clients);

    useEffect(() => {
        dispatch(getClients());
    }, [routeParams]);

    return (
        <LoggedInView fullWidth={false}>
            <ClientSearch />
            <ClientsTable />
            <Pagination totalItems={calientsState.total} itemsPerPage={30} />
        </LoggedInView>
    )

}